import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAddInquiryAnswer } from "../../../../../api/inquiries/1on1-inquiry/use-1on1-inquiry-answer";
import {
  fetchInquiryDownload,
  useInquiryById,
} from "../../../../../api/inquiries/1on1-inquiry/use-1on1-inquiry-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import { convertDateToDateTime } from "../../../../../helper/formatDate/formate-date";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";
import Navigation from "../../Components/navigation";

function Hospital1on1Component({
  inquiryData,
  handleDownloadImages,
  images,
  isEditMode,
  toggleEdit,
  defaultHasAnswer,
  onChangeAnswer,
  handleBackToList,
  setIsEditMode,
  handleSubmitInquiry,
  answer,
}) {
  return (
    <div className="mt-5">
      <div>
        <h2 className="font-bold text-[14px]">1:1 문의</h2>
        <div className="mt-[10px]">
          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="분류">
                <span className="p-2">1:1 문의</span>
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="문의일시">
                <span className="p-2">
                  {convertDateToDateTime(inquiryData.createdAt)}
                </span>
              </FieldBox>
            </div>
          </div>
          <FieldBox label="작성자">
            <span className="p-2">
              ({inquiryData.hospital?.name}) {inquiryData.hospitalMember?.email}
            </span>
          </FieldBox>
          <FieldBox label="문의 제목">
            <span className="p-2">{inquiryData.title}</span>
          </FieldBox>
          <FieldBox label="문의 내용">
            <div className="p-2 min-h-[100px]">{inquiryData.question}</div>
          </FieldBox>

          <FieldBox
            isLast
            label={
              <div>
                <div>첨부파일 목록</div>
                {/* <button
                  onClick={handleDownloadImages}
                  className="mt-2 p-1 border border-[#CDCDCD] rounded-[4px] bg-white"
                >
                  전체 다운로드
                </button> */}
              </div>
            }
          >
            <div className="p-2 min-h-[100px] flex gap-4">
              {images?.length > 0
                ? images.map((url, index) => (
                    <div key={`${url}-${index}`}>
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#0070ef] underline"
                      >
                        첨부파일{index + 1}
                      </a>
                    </div>
                  ))
                : "첨부파일이 없습니다."}
            </div>
          </FieldBox>
        </div>
      </div>
      <div className="mt-[30px]">
        <div className="flex justify-between items-center">
          <h2 className="font-bold text-[14px]">관리자 답변</h2>
          {!isEditMode && (
            <Button
              onClick={toggleEdit}
              primary
              text={defaultHasAnswer ? "답변수정" : "답변하기"}
            />
          )}
        </div>
        <div className="mt-[10px]">
          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="처리상태">
                {inquiryData.status === "PENDING" ? (
                  <span className="text-[#e80000]">답변대기</span>
                ) : (
                  "답변완료"
                )}
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="답변일시">
                <span className="p-2">
                  {inquiryData.answeredAt
                    ? convertDateToDateTime(inquiryData.answeredAt)
                    : ""}
                </span>
              </FieldBox>
            </div>
          </div>
          <FieldBox
            className={`${!isEditMode ? "bg-[#fafafa]" : ""} text-[#999999]`}
            isLast
            label="답변 내용"
          >
            {isEditMode ? (
              <textarea
                className="p-2 min-h-[150px] w-full focus:outline-none text-black"
                onChange={onChangeAnswer}
                defaultValue={defaultHasAnswer ? inquiryData.answer : ""}
                placeholder="답변을 입력해주세요."
              />
            ) : (
              <div
                className={`p-2 min-h-[150px] ${
                  inquiryData.answer ? "text-[#000]" : "text-[#999999]"
                }`}
              >
                {inquiryData.answer ?? "등록된 답변이 없습니다. "}
              </div>
            )}
          </FieldBox>
        </div>
      </div>
      {!isEditMode ? (
        <div className="mt-[30px] flex justify-center">
          <Button
            onClick={handleBackToList}
            className="py-[8.5px]"
            text="목록"
          />
        </div>
      ) : (
        <div className="mt-[30px] flex justify-end">
          <div className="flex items-center gap-3">
            <Modal
              description={
                <span>
                  입력한 답변을 입력취소하시겠습니까? 취소할 경우, 입력한 정보는
                  저장
                  <br />
                  되지 않습니다.
                </span>
              }
              onSubmit={() => setIsEditMode(false)}
            >
              <Button type="button" className="py-[8.5px]" text="입력취소" />
            </Modal>
            <Modal
              description={
                <span>
                  입력한 답변을 등록하시겠습니까? 등록완료가 될 경우, 회원에게
                  관리자
                  <br />
                  답변 알림이 발송됩니다
                </span>
              }
              onSubmit={handleSubmitInquiry}
            >
              <Button
                type="button"
                primary
                className="py-[8.5px]"
                text={defaultHasAnswer ? "수정완료" : "등록완료"}
                isDisabled={answer === ""}
              />
            </Modal>
          </div>
        </div>
      )}
    </div>
  );
}

const Hospital1on1DetailPage = () => {
  const { id1on1, id } = useParams();
  const { data } = useInquiryById(id1on1);
  const inquiryData = data?.data;
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const defaultHasAnswer = inquiryData?.answer?.length > 0;
  const [answer, setAnswer] = useState(inquiryData?.answer ?? "");
  const { mutate: addInquiryAnswer } = useAddInquiryAnswer();
  const images = inquiryData?.attachs?.map((res) =>
    res?.includes("flotus-bucket") ? res.split("/")[6] : res
  );
  const handleBackToList = () => {
    navigate(`/hospital/${id}/1on1`);
  };

  const toggleEdit = () => {
    setIsEditMode(!isEditMode);
  };

  const onChangeAnswer = (e) => {
    setAnswer(e.target.value);
  };

  const handleSubmitInquiry = async () => {
    const payload = {
      inquiryId: inquiryData.id,
      answer: answer,
    };
    try {
      await addInquiryAnswer(payload);
      setIsEditMode(false);
    } catch (error) {}
  };

  async function handleDownloadImages() {
    await fetchInquiryDownload(id1on1).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `attach-${Date.now()}.zip`);
      document.body.appendChild(link);
      link.click();
    });
  }

  return (
    <div>
      <TitlePage title={"1:1 문의 > 1:1 문의 상세"} />
      <Navigation id="1on1" hospitalId={id} />
      <div className="mt-8">
        <Hospital1on1Component
          inquiryData={inquiryData}
          handleDownloadImages={handleDownloadImages}
          images={images}
          isEditMode={isEditMode}
          toggleEdit={toggleEdit}
          defaultHasAnswer={defaultHasAnswer}
          onChangeAnswer={onChangeAnswer}
          handleBackToList={handleBackToList}
          setIsEditMode={setIsEditMode}
          handleSubmitInquiry={handleSubmitInquiry}
          answer={answer}
        />
      </div>
    </div>
  );
};

export default Hospital1on1DetailPage;
